import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/gy-apartment'

let api = {
  getEpidemicRegisterPage: `${baseUrl}/epidemicRegister/getPage`,

  getTempratureDetectPage: `${baseUrl}/tempratureDetect/getPage`,

  exportTempratureDetect: `${baseUrl}//tempratureDetect/export`,

  isolationTempratureDetect: `${baseUrl}/tempratureDetect/isolation`,

  // 人数统计
  personCount: `${baseUrl}/overview/getPersonCount`,

  // 员工疫区分布
  keyAreaCount: `${baseUrl}/overview/getKeyAreaCount`,

  // 七日测温人数统计
  tempratureCountList: `${baseUrl}/overview/getTempratureCountList`,

  // 异常人员跟踪
  abnormalCountPage: `${baseUrl}/overview/getAbnormalCountPage`,

}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/epidemicSituation.js